import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { TokenService } from '../services/token.service';

export const authGuard: CanActivateFn = async () => {
  const tokenService = inject(TokenService);
  const authService = inject(AuthService);

  if (tokenService.isAuthenticated()) {
    return true;
  }

  await authService.initiateLogin();

  return false;
};
